export default {
    '1': 'Заказан не тот товар',
    '2': 'Дублирующий заказ',
    '3': 'Невозможно получить',
    '4': 'Другие причины',
    '-连接已建立-': '-Соединение установлено-',
    ',才可提币': ', чтобы вывести средства',
    '[code]值错误': 'Неверное значение [code]',
    '[symbol]参数为空': 'Параметр [symbol] пуст',
    homeDownloadtips41: 'Приложение продавца',
    '不能为空': 'Не может быть пустым',
    '不在交易时段': 'Вне торговой сессии',
    '不在可提现时间内': 'Вне времени вывода средств',
    '参数错误': 'Ошибка параметра',
    '参数异常，消息获取失败': 'Аномалия параметра, не удалось получить сообщение',
    '操作成功': 'Операция выполнена успешно',
    '操作类型不能小于0': 'Тип операции не может быть меньше 0',
    '操作类型不是整数': 'Тип операции не является целым числом',
    '操作类型为空': 'Тип операции пуст',
    '产品不存在': 'Товар не существует',
    '产品剩余数量不足': 'Недостаточно остатка товара',
    '承兑商不存在': 'Продавец не существует',
    '程序错误': 'Ошибка программы',
    '持有币种不足': 'Недостаточно средств в валюте',
    '充值价值不得大于最大限额': 'Сумма пополнения не может превышать максимальный лимит',
    '充值价值不得小于最小限额': 'Сумма пополнения не может быть меньше минимального лимита',
    '充值链错误': 'Ошибка сети пополнения',
    '充值数量不能小于等于0': 'Сумма пополнения не может быть меньше или равна 0',
    '存在不同杠杆的持仓单': 'Существуют позиции с разным плечом',
    '存在重复的角色名称': 'Существует дублирующее имя роли',
    '大于最大采购数量': 'Больше максимального количества покупки',
    '代理层级错误': 'Ошибка уровня агента',
    '待付款的订单无法放行': 'Неоплаченный заказ не может быть выпущен',
    '当前地址格式错误': 'Неверный формат текущего адреса',
    '当前订单不为待付款状态，无法取消': 'Заказ не в статусе ожидания оплаты, отмена невозможна',
    '当前还需交易': 'Требуются дополнительные сделки',
    '当日才可申购': 'Подписка возможна только в тот же день',
    '当日可提现次数不足': 'Недостаточно выводов на сегодня',
    '登陆密码不符合设定': 'Пароль для входа не соответствует требованиям',
    '登陆密码长度不符合设定': 'Длина пароля для входа не соответствует требованиям',
    '登录过期，请重新登录': 'Сессия истекла, войдите снова',
    '登录密码必须6-12位': 'Пароль для входа должен содержать 6-12 символов',
    '登录密码不能为空': 'Пароль для входа не может быть пустым',
    '登录失败': 'Ошибка входа',
    '电话号码已绑定': 'Номер телефона уже привязан',
    '电话号码已绑定其他用户': 'Номер телефона уже привязан к другому пользователю',
    '订单不存在': 'Заказ не существует',
    '订单已取消': 'Заказ отменён',
    '订单已取消，无法放行': 'Заказ отменён, выпуск невозможен',
    '订单已完成，无法放行': 'Заказ завершён, выпуск невозможен',
    '发现新版本，请升级到最新版本': 'Доступна новая версия, обновите до последней версии',
    '服务器错误': 'Ошибка сервера',
    '服务器错误(500)': 'Ошибка сервера (500)',
    '该产品未上架': 'Этот товар не размещён',
    '该产品已上市，无法购买': 'Этот товар уже размещён, покупка невозможна',
    '该订单已取消': 'Этот заказ отменён',
    '该广告剩余数量不足': 'Недостаточно остатка этого объявления',
    '该基金尚未开放购买': 'Этот фонд ещё не открыт для покупки',
    '该基金尚已封闭': 'Этот фонд уже закрыт',
    '该邮箱已被订阅': 'Этот e-mail уже подписан',
    '格式有误:充值金额不能小于1(包含俩位小数)': 'Ошибка формата: сумма пополнения не может быть меньше 1 (два знака после запятой)',
    '跟单倍数输入错误': 'Неверный ввод множителя копи-трейдинга',
    '跟单参数输入错误': 'Неверный ввод параметров копи-трейдинга',
    '更新提醒': 'Напоминание об обновлении',
    '工作地址不能为空': 'Рабочий адрес не может быть пустым',
    '购买矿机时间不得低于托管订单剩余时间': 'Срок покупки майнинг-машины не может быть меньше оставшегося времени заказа на хостинг',
    '广告不存在': 'Объявление не существует',
    '广告已下架': 'Объявление снято',
    '基金剩余购买金额不足': 'Недостаточно оставшейся суммы покупки фонда',
    '家庭地址不能为空': 'Домашний адрес не может быть пустым',
    '交易员不存在': 'Трейдер не существует',
    '交易员不能跟随自己': 'Трейдер не может подписаться на себя',
    '交易员跟随人数已满': 'Число подписчиков трейдера заполнено',
    '交易员未开启带单': 'Трейдер не включил копи-трейдинг',
    '交易员无法跟随另一个交易员': 'Трейдер не может подписаться на другого трейдера',
    '角色被用户关联，不可删除': 'Роль связана с пользователями, удаление невозможно',
    '角色不存在': 'Роль не существует',
    '金额不在购买区间': 'Сумма не входит в диапазон покупки',
    '金额错误': 'Ошибка суммы',
    '旧密码不能为空': 'Старый пароль не может быть пустым',
    '旧密码不正确': 'Старый пароль неверен',
    '可平仓合约张数不足': 'Недостаточно контрактов для закрытия',
    '矿机不存在': 'Майнинг-машина не существует',
    '矿机未解锁，无法购买': 'Майнинг-машина не разблокирована, покупка невозможна',
    '历史基金无法购买': 'Исторические фонды нельзя купить',
    '连续输入错误三次，请3分钟后再试': 'Три неверных ввода подряд, повторите через 3 минуты',
    '领取成功': 'Успешно получено',
    '买入金额需要在区间内': 'Сумма покупки должна быть в пределах диапазона',
    '卖方无法取消该订单': 'Продавец не может отменить этот заказ',
    '没有找到用户': 'Пользователь не найден',
    verificationCode: 'Код подтверждения',
    pleaseEnterVerificationCode: 'Введите код подтверждения',
    pleaseEnterUsername: 'Введите имя пользователя',
    username: 'Имя пользователя',
    getVerificationCode: 'Получить код',
    tryAgainLater: 'секунд до повтора',
    '密码必须6-12位': 'Пароль должен содержать 6-12 символов',
    '密码不能为空': 'Пароль не может быть пустым',
    '密码不正确': 'Пароль неверен',
    '您当前可分配额度不足': 'Ваш текущий распределяемый лимит недостаточен',
    '您没有符合条件的收款方式': 'У вас нет подходящего способа получения средств',
    '您已存在订单': 'У вас уже есть заказ',
    '您已购买过体验矿机,不得重复购买': 'Вы уже купили пробную майнинг-машину, повторная покупка невозможна',
    '亲属地址不能为空': 'Адрес родственника не может быть пустым',
    '亲属电话不能为空': 'Телефон родственника не может быть пустым',
    '亲属关系不能为空': 'Степень родства не может быть пустой',
    '亲属姓名不能为空': 'Имя родственника не может быть пустым',
    '请检查网络连接': 'Проверьте сетевое соединение',
    '请上传图片': 'Загрузите изображение',
    '请稍后再试': 'Повторите попытку позже',
    '请稍后重试': 'Повторите попытку позже',
    '请输入充值币种': 'Введите валюту пополнения',
    '请输入内容': 'Введите содержимое',
    '请输入搜索关键字': 'Введите ключевое слово для поиска',
    '请输入正确的货币数量': 'Введите правильное количество валюты',
    '请输入正确的金额': 'Введите правильную сумму',
    '请输入正确的数量': 'Введите правильное количество',
    '请输入正确的质押金额': 'Введите правильную сумму стейкинга',
    '请输入正确的质押天数': 'Введите правильное число дней стейкинга',
    '请填写正确的电话号码': 'Введите правильный номер телефона',
    '请填写正确的验证码': 'Введите правильный код подтверждения',
    '请填写正确的邮箱地址': 'Введите правильный адрес e-mail',
    '请先绑定谷歌验证器': 'Сначала привяжите Google Authenticator',
    '请先添加收款方式': 'Сначала добавьте способ получения средств',
    '请先通过高级认证': 'Сначала пройдите расширенную верификацию',
    '请选择买卖方式': 'Выберите способ покупки/продажи',
    '请选择正确的币种': 'Выберите правильную валюту',
    '请重新登录': 'Войдите снова',
    '渠道未开通': 'Канал не активирован',
    '取消': 'Отмена',
    '确认': 'Подтвердить',
    '申购数量错误': 'Неверное количество подписки',
    '申请成功': 'Заявка успешна',
    '身份证已实名过!': 'Удостоверение личности уже верифицировано!',
    '审核已通过': 'Проверка пройдена',
    '审核中': 'На проверке',
    '实名认证未通过，无法进行高级认证': 'Верификация личности не пройдена, расширенная верификация невозможна',
    '收款方输入错误': 'Неверный ввод получателя',
    '授权状态未成功': 'Статус авторизации не успешен',
    '赎回状态异常': 'Аномальный статус погашения',
    '所选汇率不存在': 'Выбранный обменный курс не существует',
    '提币数量不能小于等于0': 'Сумма вывода не может быть меньше или равна 0',
    '提交失败，当前有未处理订单': 'Ошибка отправки, есть необработанные заказы',
    '提示': 'Уведомление',
    '提现不得大于限额': 'Вывод не может превышать лимит',
    '提现不得小于限额': 'Вывод не может быть меньше лимита',
    '图片不得大于10M': 'Изображение не может превышать 10 МБ',
    '图片不得大于2M': 'Изображение не может превышать 2 МБ',
    '图片大小不能超过2M！': 'Размер изображения не может превышать 2 МБ!',
    '图片上传失败': 'Ошибка загрузки изображения',
    '推荐码不正确': 'Реферальный код неверен',
    '推荐人无权限推荐': 'У реферера нет прав на приглашение',
    '委托数量(张)必填': 'Количество ордера (контракты) обязательно',
    '委托数量(张)不能小于等于0': 'Количество ордера (контракты) не может быть меньше или равно 0',
    '未绑定谷歌验证器': 'Google Authenticator не привязан',
    '未绑定手机号': 'Номер телефона не привязан',
    '未绑定邮箱': 'E-mail не привязан',
    '未发现授权记录': 'Запись авторизации не найдена',
    '未实名认证，是否认证？': 'Не верифицировано. Верифицировать сейчас?',
    '未授权访问': 'Несанкционированный доступ',
    '未找到符合条件的匹配订单': 'Подходящий заказ не найден',
    '未找到匹配的收益记录': 'Соответствующая запись о доходах не найдена',
    myComment: 'Мои отзывы',
    myPoint: 'Мои баллы',
    accountInfo: 'Информация об аккаунте',
    myBalance: 'Мой баланс',
    myCoupon: 'Мои купоны',
    unused: 'Не использовано',
    used: 'Использовано',
    expired: 'Истекло',
    expires: 'Действует до',
    minSpend: 'От',
    availableBalance: 'Доступный баланс',
    personalDeposit: 'Баланс',
    useDepositBalance: 'Использовать баланс для скидки',
    depositDeduct: 'Списание с баланса',
    useMaxDeposit: 'Полное списание',
    balanceHistory: 'История баланса',
    recordCount: 'Всего {count} записей',
    depositType: 'Тип транзакции',
    balanceAfter: 'Остаток',
    depositTypeRecharge: 'Пополнение баланса',
    depositTypeAdjustment: 'Корректировка баланса',
    depositTypeOrderPayment: 'Оплата заказа',
    depositTypeOrderRefunds: 'Возврат заказа',
    depositTypeDistributionCommission: 'Комиссия дистрибуции',
    depositTypeDistributionWithdrawal: 'Вывод дистрибуции',
    depositTypeOther: 'Прочее',
    income: 'Доход',
    expense: 'Расход',
    description: 'Описание',
    myFootprint: 'Мои просмотры',
    '无权限': 'Нет прав',
    '无效的UID': 'Недействительный UID',
    '系统参数错误': 'Ошибка системного параметра',
    '系统存在相同[系统登录名]！': 'В системе уже есть такое же [имя для входа]!',
    '系统错误，请稍后重试': 'Системная ошибка, повторите позже',
    '下单不能小于最小金额限制': 'Заказ не может быть меньше минимальной суммы',
    '校验IP不合法': 'Недействительный проверочный IP',
    '新密码不能为空': 'Новый пароль не может быть пустым',
    '新密码不一致': 'Новые пароли не совпадают',
    '新密码确认不能为空': 'Подтверждение нового пароля не может быть пустым',
    '行情获取异常，稍后再试': 'Не удалось получить рыночные данные, повторите позже',
    '验证类型不能为空': 'Тип верификации не может быть пустым',
    '验证码不能为空': 'Код подтверждения не может быть пустым',
    '验证码不正确': 'Код подтверждения неверен',
    '页码不能小于等于0': 'Номер страницы не может быть меньше или равен 0',
    '页码不是整数': 'Номер страницы не является целым числом',
    '已领取': 'Уже получено',
    '用户不存在': 'Пользователь не существует',
    '用户名必须由数字和英文字母组成': 'Имя пользователя должно состоять из цифр и латинских букв',
    '用户名不存在': 'Имя пользователя не существует',
    '用户名不符合设定': 'Имя пользователя не соответствует требованиям',
    '用户名不能为空': 'Имя пользователя не может быть пустым',
    '用户名参数为空': 'Параметр имени пользователя пуст',
    '用户名重复': 'Имя пользователя дублируется',
    '用户剩余数量不足': 'Недостаточно остатка пользователей',
    '用户已跟随交易员': 'Пользователь уже подписан на трейдера',
    '邮箱已绑定': 'E-mail уже привязан',
    '邮箱已绑定其他用户': 'E-mail уже привязан к другому пользователю',
    '余额不足': 'Недостаточно средств',
    shop_order_insufficientBalance: 'Недостаточно средств на счёте',
    '帐户异常需要进行C3认证，请联系在线客服。': 'Аномалия аккаунта, требуется верификация C3. Обратитесь в онлайн-поддержку.',
    '找不到用户': 'Пользователь не найден',
    flashSale: 'Флеш-распродажа',
    groupBuy: 'Групповая покупка',
    groupBuying: 'Совместная покупка',
    couponCenter: 'Центр купонов',
    pointMall: 'Магазин баллов',
    liveList: 'Прямой эфир',
    endsIn: 'Заканчивается через',
    soldOut: 'Продано',
    people: 'чел.',
    joined: 'Присоединились',
    startGroup: 'Начать групповую покупку',
    getCoupon: 'Получить',
    '直线关系，不能修改推荐': 'Прямая связь, реферала нельзя изменить',
    '重复提交': 'Повторная отправка',
    '转账币种不能为空': 'Валюта перевода не может быть пустой',
    '转账数量不能小于等于0': 'Сумма перевода не может быть меньше или равна 0',
    '状态不能小于0': 'Статус не может быть меньше 0',
    '状态不是整数': 'Статус не является целым числом',
    '资金密码必须6-12位': 'Финансовый пароль должен содержать 6-12 символов',
    '资金密码不符合设定': 'Финансовый пароль не соответствует требованиям',
    '资金密码不能为空': 'Финансовый пароль не может быть пустым',
    '资金密码错误': 'Ошибка финансового пароля',
    '资金密码长度不符合设定': 'Длина финансового пароля не соответствует требованиям',
    'UID不能为空': 'UID не может быть пустым',
    required: 'Обязательное поле',
    nickname: 'Псевдоним',
    enterNickname: 'Введите псевдоним',
    gender: 'Пол',
    male: 'Мужской',
    female: 'Женский',
    secret: 'Не указывать',
    birthday: 'День рождения',
    selectDate: 'Выберите дату',
  cancelOrderMap: {
    0: "Я не хочу этого.",
    1: "Неуместный продукт",
    2: "Дублирующий заказ",
    3: "Не удалось получить",
    4: "Другие причины",
  },
  "获取验证码": "Получить код",
  "请输入验证码": "Пожалуйста, введите код",
  "验证码错误": "Код неверен",
  "验证码": "Код",
  "发送": "Отправить",
  "已发送，请注意查收":
    "Отправлено, пожалуйста, проверьте почту",
  "请选择": "Пожалуйста, выберите",
  "仅能绑定一个收款地址!": "Можно привязать только один адрес для получения платежей!",
  "绑定成功": "Привязка успешна",
  "提款地址绑定": "Привязка адреса снятия наличных",
  "电商批发商场": "Оптовый рынок электронной коммерции",
  "请输入完整的支付密码!" : "Пожалуйста, введите полный пароль для оплаты!",
  "用户未发表评论": "Пользователь не прокомментировал",
  "订单": "Заказ",
  "下单成功，等待付款": "Заказ успешно оформлен, ждем оплаты",
  "下单成功，付款成功": "Заказ успешно размещен, оплата прошла успешно",
  "已发货，正在运输中": "Отгружено, в транспорте",
  "订单已取消，原因:手动发起取消订单": "Заказ отменен. Причина: Отменить заказ вручную.",
  "订单已取消，原因:超时自动取消订单": "Заказ отменен. Причина: Заказ будет автоматически отменен по истечении времени ожидания.",
  "商家已确认，已进入备货状态": "Продавец был подтвержден и вошел в состояние склада.",
  "系统发货成功": "Доставка системы прошла успешно",
  "订单已签收": "Заявка принята",
  "发起退款申请": "Инициировать запрос на возврат",
  "退款成功": "Возврат выполнен",
  "退款失败": "Не удалось вернуть деньги",
  "订单退款成功": "Возврат заказа выполнен",
  "订单退款失败": "Не удалось вернуть заказ",
  "系统默认好评": "Система по умолчанию дает положительные отзывы",
  "请输入关键字搜索": "Пожалуйста, введите ключевое слово для поиска",
  "猜你喜欢": "Думаю, тебе это нравится",
  "订单已完成": "Заказ выполнен",
  "热销推荐": "Горячие рекомендации по продажам",
  "头像选择": "Выбор аватара",
  "修改头像": "Изменить свой аватар",
  subOrder: "Подтвердить заказ",

  "mailboxCheck": "Пожалуйста, заполните правильный адрес электронной почты",
  "switchLang": "Пожалуйста, переключитесь на другой язык для просмотра",
  "myCart": "Моя корзина",
  "notQua": "Квалификационные условия не соблюдены.",
  "noSmaller": "Применяемая сумма не может быть меньше",
  "nomax": "Максимальная сумма заявки не может превышать",
  "evaluationUploading": "У вас все еще загружаются фотографии. Пожалуйста, повторите попытку позже",
  "evaluateInput": "Обзор с картинками",
  "moneyOrderStatus": "Статус заказа",
  "coinBlock": "Валютное соглашение",
  "dealing": "В процессе",
  "dealSuccess": "Успешный",
  "dealFail": "Неудача",
  "payCertificate": "Платежный сертификат",
  "handleFee": "Плата за обслуживание",
  "highOpinion": "Хорошие отзывы",
  "mediumOpinion": "Средний обзор",
  "lowOpinion": "Плохие отзывы",
  "hasImage": "С картинками",
  "rechargeMethod": "Режим перезарядки",
  "scanAndDown": "Сканировать QR-код Скачать приложение",
  "receivedAddress": "Адрес получения",
  "ActualLedger": "Фактическое получение",
  "view": "Вид",
  "withdrawNum": "Количество снятия наличных",
  "rechargeNum": "Количество пополнения",
  "date": "Дата",
  "walletHistory": "История кошелька",
  "accountBalance": "Баланс",
  "accountReview": "Обзор аккаунта",
  "rated": "Рассмотрено",
  "receiver": "Получатель",
  "orderStatus": "Положение дел",
  "orderTime": "Время",
  "tax": "Налогообложение",
  "discount": "Скидка",
  "productInfo": "Информация о продукте",
  "paramError": "Ошибка параметра",
  "orderInfo": "Запросить информацию",
  "rebuy": "еще один заказ",
  "pleaseCorrectAddress": "Пожалуйста, введите правильный адрес для снятия наличных",
  "pleaseInputCorrectNumber": "Пожалуйста, введите число больше 0",
  "vcodePass": "Проверка прошла!",
  "vcodeFail": "Ошибка авторизации. Пожалуйста, повторите",
  "uploading": "Загрузка...",
  "uploadSuccess": "Загружено успешно",
  "uploadError": "Загрузка не удалась. Пожалуйста, попробуйте еще раз",
  "registerSuccess": "Регистрация прошла успешно",
  "pleaseSetMobileNumber": "Пожалуйста, укажите номер телефона",
  "unSelectedProduct": "Вы не выбрали товар",
  "loginSuccess": "Вход выполнен успешно",
  "pleaseSetAreaCode": "Введите название страны и код города для поиска",
  "login": "Авторизоваться",
  "register": "Постановка на учет",
  "logout": "Выход",
  "noData": "Данные не найдены",
  "search": "Поиск",
  "historySearch": "Исторический поиск",
  "empty": "Пустой",
  "home": "Домашняя страница",
  "favorableRate": "Рейтинг хороших отзывов",
  "classification": "Категория",
  "searchTips": "Исходный поиск/продукт/поставщик/заказ",
  "dailyNewArrival": "Список ежедневных новых продуктов",
  "more": "Более",
  "recommend": "Рекомендация",
  "recommendedProducts": "Рекомендуемые продукты",
  "recommendedStore": "Рекомендуемые магазины",
  "buyNow": "Купить сейчас",
  "addCart": "Добавить в корзину",
  "complex": "Интегрированный",
  "price": "Цена",
  "retailPrice": "Розничная цена",
  "originPrice": "Изначальная цена",
  "service": "Обслуживание клиентов",
  "collect": "Избранное",
  "sold": "Объем продаж",
  "pageviews": "Количество просмотров",
  "quantity": "Количество",
  "freight": "Груз",
  "shipping": "Перевозки",
  "ship": "Лодка",
  "buyTips": "Отправка в течение 24 часов после оформления заказа. Следующие заказы находятся на логистическом контроле и могут быть отправлены с опозданием. Пожалуйста, обратите внимание на информацию о логистике или свяжитесь со службой поддержки клиентов.",
  "totalPrice": "Итоговая цена",
  "addCartMessage": "Успешно добавлено в корзину",
  "addCartMessageFaild": "Товар уже есть в корзине.",
  "myAccount": "Мой qсчет",
  "buyHistory": "Записи о покупках",
  "wishlist": "Любимые продукты",
  "trackOrder": "Заказ",
  "account": "Счет:",
  "sellerZone": "Торговая зона",
  "beSeller": "Стать торговцем",
  "sellerPanelLogin": "Вход для продавца",
  "footTip": "© Copyright МетаШоп ООО 2024",
  "footTips": "{name} Limited уполномочена и регулируется Управлением финансового надзора в качестве кредитного брокера (713206) и работает исключительно с кредитором Home Retail Group CardServices Limited как {name} Financial Services. Финансовые услуги {name} уполномочены и регулируются Управлением финансового надзора для предоставления кредита (716148). Home Retail GroupCard Services Limited зарегистрирована в Соединенном Королевстве (04007072) по адресу Avebury, 489-499 Avebury Boulevard, Milton Keynes, United Kingdom. МК9 2НЗ.",
  "item": "Статья",
  "checkout": "Разместить заказ",
  "productDescription": "Описание продукта",
  "userEvaluation": "Отзывы Пользователей",
  "AllProducts": "Все продукты",
  "followers": "Следовать",
  "sales": "Объем продаж",
  "visitStore": "Посетите магазин",
  "authentic": "100% подлинный",
  "dayReturns7": "возврат 7 дней",
  "shippingDiscounts": "Скидка на фрахт",
  "safePayment": "Безопасная оплата",
  "followed": "Подписано",
  "dashboard": "Приборная доска",
  "myOrder": "Мой заказ",
  "setUp": "Настраивать",
  "successTips": "Успешный",
  "copySuccess": "Репликация выполнена успешно",
  "balance": "Баланс (USDT)",
  "sort": "Тип",
  "commodity": "Продукт",
  "browse": "Объем продаж",
  "recharge": "Перезарядка",
  "commodityCollection": "Коллекция продуктов",
  "withdraw": "Выдача наличных",
  "defaultAddress": "Адрес по умолчанию",
  "addNewAddress": "Добавить новый адрес",
  "withdrawRecord": "Запись о снятии наличных",
  "serialNumber": "№ заказа.",
  "time": "Время",
  "amount": "Количество",
  "processing": "В процессе",
  "fail": "Неудача",
  "blockchainNetwork": "Блокчейн сеть",
  "records": "Записывать",
  "withdrawAddress": "Адрес для снятия наличных",
  "withdrawInputTips": "Пожалуйста, введите адрес для вывода",
  "copy": "Репликация",
  "enterTips": "Пожалуйста входите",
  "actualAccount": "Фактический счет",
  "handlingFee": "Плата за обслуживание",
  "confirm": "Подтвердить получение",
  "previous": "Предыдущий шаг",
  "pleaseEnterAddress": "Пожалуйста, введите адрес",
  "pleaseEnterQuantity": "Пожалуйста, введите количество",
  "withdrawSuccess": "Заказы отправлены успешно",
  "saveQr": "Сохранить QR-код",
  "pleaseEnterAmount": "Пожалуйста, введите сумму пополнения",
  "expectedArrival": "Ожидаемое прибытие",
  "currentRate": "Текущий обменный курс",
  "uploadTips": "Подтверждение платежа (загрузить снимок экрана с деталями платежа)",
  "clickUpload": "Нажмите, чтобы загрузить",
  "uploadPhoto": "Пожалуйста, загрузите фотографии",
  "rechargeSuccessful": "Пополнение успешно",
  "rechargeTips": "Подсказка о пополнении: «Пожалуйста, введите фактическую сумму перевода правдиво. В противном случае система может не пройти одобрение и повлиять на ход пополнения.",
  "rechargeRecord": "Запись пополнения",
  "all": "Все",
  "pending": "Быть оплаченным",
  "cancelled": "Отменено",
  "delivered": "Для отправки",
  "confirmed": "Подтвержденный",
  "receipt": "быть полученным",
  "harvested": "Полученный",
  "comment": "Для рассмотрения",
  "refund": "Возврат/после продажи",
  "cancelOrder": "Отменить заказ",
  "cancelReason": "Причина отмены",
  "cancelOrderTitle": "Пожалуйста, выберите причину отмены заказа",
  "returnOrderTitle": "Пожалуйста, выберите причину возврата",
  "refundInstructions": "Инструкции по возврату",
  "returnDetailTips": "Пожалуйста, оставьте отзыв о товаре",
  "cancel": "Отменить заказ",
  "cancelOrder1": "Товар не получен",
  "cancelOrder2": "Не нравится, не хочу",
  "cancelOrder3": "Продавец отправил не тот товар",
  "cancelOrder4": "Поддельный бренд",
  "cancelOrder5": "Меньше отгрузки, пропущенная отгрузка",
  "cancelOrder6": "Товар получен поврежденным",
  "cancelOrder7": "Есть проблема с качеством",
  "cancelOrder8": "Обсудить возврат с продавцом",
  "cancelOrder9": "Другие причины",
  "cancelOrderSuccess": "Заказ успешно отменен",
  "returnOrderSuccess": "Отправить успешно",
  "orderName": "Имя",
  "orderEmail": "Электронная почта",
  "orderAddress": "Адрес",
  "orderNation": "Страна",
  "orderState": "Положение дел",
  "orderCity": "Город",
  "orderPostCode": "Почтовый индекс",
  "orderAmount": "Количество",
  "orderPrefix": "Общий заказ",
  "orderFee": "Налоги",
  "orderSpecification": "Спецификация",
  "orderCommodity": "Продукт",
  "orderQuantity": "Количество",
  "orderUnitprice": "Цена за единицу товара",
  "orderFreight": "Груз",
  "orderTax": "налог",
  "orderTotal": "Общий",
  "PaymentOrder": "Платежное поручение",
  "Evaluate": "Обзор",
  "CancelOrder": "Отменить заказ",
  "RemindShip": "Напоминание об отправке",
  "Refund": "Возвращать деньги",
  "Submitareview": "Отправить отзывы",
  "Information": "Информация",
  "wrongPassword": "Ошибка пароля более 3 раз. Повторите попытку завтра.",
  "Operate": "Операция",
  "Item": "Предметы)",
  "From": "От",
  "hint": "Советы",
  "CheckDetails": "Посмотреть детали",
  "Payment": "Оплата",
  "Cancel": "Отмена",
  "refundSuccessfully": "Возврат выполнен",
  "pendingPayment": "Быть оплаченным",
  "pay": "Оплата",
  "LoginPassword": "Логин Пароль",
  "sure": "Конечно",
  "shippingAddress": "Адрес получения",
  "transactionPassword": "Пароль транзакции",
  "markDefaultAddress": "Отметить как адрес доставки по умолчанию",
  "edit": "Отредактировано",
  "delete": "Удалить",
  "Opt": "Выбирать",
  "piece": "шт",
  "orderDetails": "Информация для заказа",
  "shopCollection": "Добавить магазин в избранное",
  "addAddress": "Добавить новый адрес",
  "signUp": "Постановка на учет",
  "loginTips": "У вас уже есть аккаунт?",
  "loginIn": "Авторизоваться",
  "mobile": "Номер телефона",
  '购物车还没有商品': "В корзине еще нет товаров",
  '去购物': "Иди за покупками",
  "modifyAddress": "Изменить адрес",
  "desc": "Сделать адресом по умолчанию",
  "keep": "Поддерживать",
  "onlineService": "Онлайн-сервисы",
  "send": "Отправлять",
  "EsShop": "Интернет-магазин",
  "desc3": "Введите пароль транзакции",
  "desc4": "Введите пароль транзакции",
  "desc6": "Введите пароль транзакции еще раз",
  "setUpPayPaw": "Установить пароль транзакции",
  "setSuccess": "Установка прошла успешно",
  "confirmPayPaw": "Подтвердите пароль транзакции",
  "paymentSuccessful": "Платеж прошел успешно",
  "desc5": "Неверный адрес доставки? Контакт",
  "customeService": "Онлайн обслуживание клиентов",
  "BackHome": "Вернуться на главную страницу",
  "Checkorder": "Посмотреть заказ",
  "ForgotPassword": "Забыть пароль?",
  "signIn": "Авторизоваться",
  "noAccount": "Нет номера счета?",
  "pleaseEnterAccount": "Пожалуйста, введите номер счета",
  "pleaseEnterPassword": "Пожалуйста введите пароль",
  "password": "Пароль",
  "mobilePhone": "Номер телефона",
  "pleaseEnterPhoneNumer": "Пожалуйста, укажите номер телефона",
  "setPassword": "Установка пароля",
  "noDataFound": "Данные не найдены",
  "searchCountry": "Введите название страны и код города для поиска",
  "pleaseEnterEmail": "Пожалуйста, установите почтовый ящик",
  "invitationCode": "Код приглашения",
  "plaeseEnterInvitaionCode": "Пожалуйста, установите код приглашения",
  "pleaseSetLoginPassword": "Пожалуйста, установите пароль для входа",
  "selectDeliveryAddress": "Выберите адрес доставки",
  "totalOf": "Общий",
  "items": "Элемент",
  "orderSummary": "Итог заказа",
  "paymentMethod": "Способ оплаты",
  "Balance": "Баланс",
  "payPal": "PayPal",
  "notOpen": "Этот способ оплаты еще не доступен для вашего региона",
  "mastercard": "Мастеркард",
  "additional": "Дополнительный",
  "handlingfee": "Требуется плата за обслуживание",
  "goodsNumber": "Количество продуктов",
  "deliveryFee": "Груз",
  "totalNum": "Общий",
  "new": "Новый",
  "oldPassword": "Старый пароль",
  "pleaseEnterOldPassword": "Пожалуйста, введите старый пароль",
  "newPassword": "Новый пароль",
  "plaseeEnterNewPassword": "Пожалуйста, введите новый пароль",
  "confirmPassword": "Подтвердите пароль",
  "plaseeENterConfirmPassword": "Пожалуйста, введите пароль для подтверждения",
  "twoPawword": "Два пароля не совпадают",
  "rechargeAddress": "Адрес пополнения",
  "plaseEnterRechargeAddress": "Пожалуйста, введите адрес пополнения",
  "userCenter": "Персональный центр",
  "merchantSettled": "Вход продавца",
  "upNew": "Новый продукт в списке",
  "balanceNot": "Баланса не хватает. Пожалуйста, перезарядите.",
  "NoProductSelected": "Товар еще не выбран",
  "ShippingAddressNotSet": "Адрес доставки не указан",
  "consigneeName": "Имя получателя",
  "email": "Электронная почта:",
  "areaCode": "Международный код города",
  "phoneNumber": "Номер телефона",
  "nation": "Страна",
  "state": "Провинция/Штат/Штат",
  "city": "Город",
  "postCode": "Почтовый индекс",
  "address": "Подробный адрес",
  "addAddressOrModifyAddress": "Добавить новый адрес/Изменить адрес",
  "setAsTheDefaultAddress": "Сделать адресом по умолчанию",
  "proceed": "Продолжать",
  "btnSure": "Подтверждать",
  "pleaseInput": "Пожалуйста входите",
  "allProduct": "Все продукты",
  "myCommodityCollection": "Любимые продукты",
  "myFollowedShops": "Следите за магазином",
  "mySold": "Продал",
  "myPageviews": "Количество просмотров",
  "myPraiseRate": "Рейтинг хороших отзывов",
  "myUnfollow": "Отписаться",
  "inputNum": "Числа",
  "inpuEmailErro": "Пожалуйста, введите правильный адрес электронной почты",
  "goodsShip": "Отгрузка",
  "goodsShipTips": "Товары будут отправлены в течение 24 часов после размещения заказа. Если для следующего заказа существует контроль логистики, заказ может быть задержан. Пожалуйста, обратите внимание на информацию о логистике заказа или свяжитесь со службой поддержки клиентов.",
  "goodsFreight": "Груз",
  "goodsFreeShipping": "Бесплатно",
  "goodsFreightTips1": "1. Состав трансграничных грузовых перевозок: фрахт = плата за отправку + фрахт на дальние расстояния + плата за доставку.",
  "goodsFreightTips2": "2. Если почтовые условия не выполняются, фрахт взимается в соответствии с фактическими условиями.",
  "goodsFreightTips3": "3. Право на окончательную интерпретацию принадлежит платформе.",
  "pleaseValidPostCode": "Пожалуйста, введите более 4 цифр",
  "pleaseValidEmail": "Пожалуйста, введите правильный адрес электронной почты",
  "pleaseValidPhone": "Пожалуйста, введите правильный номер телефона",
  "productAvailable": "Этот продукт был удален",
  "validatorMaxNumber": "Сумма превышает лимит",
  "validatorRequire": "Обязательные элементы не могут быть нулевыми",
  "validatorPhone": "Пожалуйста, введите правильный номер телефона",
  "validatorEmail": "Пожалуйста, введите правильный формат электронной почты",
  "validatorPassword": "Пароль состоит из 6-12 цифр или букв(содержит специальные символы)",
  "validatorSixNumber": "Пожалуйста, введите 6 чистых цифр",
  "validatorFourMoreNumber": "Пожалуйста, введите комбинацию из 4-32 цифр или букв",
  "validatorIpRule": "Неверный формат IP",
  "validatorChineseAndEnglish": "Только для китайского и английского языков, введите диапазон: 8–64 символа.",
  "collectionSuccess": "Добавить в избранное успешно",
  "followedSuccess": "Подписаться удалось",
  "cancelSuccess": "Отменено успешно",
  "加值": "Добавить",
  "平台人工发起退款": "Платформа искусственно инициирует возврат средств",
  "银行卡": "Банковская карта",
  "提领": "Снять",
  "联系商家": "Связаться с продавцом",
  "evaluateOrder": "Обзор с картинками",
  "evaluateOrderPlaceholder": "Пожалуйста, ознакомьтесь с продуктами",
  "operationSuccess": "Операция прошла успешно",
  "confirmReceiveGoods": "Подтвердить получение товара или нет",
  "evaluateOrderSuccess": "Проверка прошла успешно",
  "yesterday": "Вчера",
  "notLogin": "Вы еще не вошли в систему.",
  "delAllHistoryRecord": "Вы уверены, что хотите удалить всю запись истории?",
  "or": "Или",
  "tipsRemindsText": "Продавец получит напоминание после напоминания об отправке",
  "tipsRemindsCount": "Напомнить можно только один раз.",
  "tipsRemindsMerchant": "Напомнить продавцам",
  "tipsRemindsSuccess": "Напоминание выполнено",
  "noCartTips": "Ваша корзина пуста. Начните делать покупки.",
  "defaultRate": "Система по умолчанию дает положительные отзывы",
  "prevPage": "Предыдущая страница",
  "nextPage": "Следущая страница",
  "returnApply": "Запрос на возврат денег",
  "returnReason": "Причина возврата",
  "returnAmount": "Сумма возврата",
  "returnRemark": "Инструкции по возврату",
  order: {
    confirm: "Подтвердить получение",
    cancel: "Отменить заказ",
    payment: "Заплатить сейчас",
    remind: "Напоминание об отправке",
    return: "Запрос на возврат товара",
    evaluate: "Проверить сейчас",
    logistics: "Посмотреть логистику",
    noRefund: "Невозмещенный",
    refunding: "Выполняется возврат",
    refundSuccess: "Возврат выполнен",
    refundFail: "Не удалось вернуть деньги",
        expressCompany: 'Курьерская служба',
        trackingNo: 'Номер отслеживания',
        noOrderShipping: 'Нет данных об отправке',
        noTransitSteps: 'Нет данных отслеживания',
        logisticsLoadFail: 'Не удалось загрузить логистику. Повторите попытку позже.'
  },
  "remindTitle": "Напоминание об отправке",
  "备注": "Примечание",
  "当前余额": "Текущий баланс",
  "remindContent": "После напоминания об отправке продавец получит напоминание. Напомнить можно только один раз.",
  "remindSuccess": "Напоминание выполнено",
  "remindRepeat": "Об этом приказе напомнили.",
  "noComments": "В настоящее время нет обзора",
  "storeSeach": "Искать товар в этом магазине",
  "storeSeachTips1": "Найдено для вас",
  "storeSeachTips2": "Похожие магазины найдены",
  "storeSeachTips3": "Дом",
  "creditTit": "Кредитные услуги",
  "getCoupons": "Получите больше купонов",
  "yourEmail": "Ваш электронный адрес",
  "subscription": "Подписки",
  "paymethods": "Способ оплаты",
  "footdec": "Пользователи глобального сайта {name} из {num} стран мира используют для расчетов {coin}. {coin} — это безграничная транзакция, которая позволяет совершать немедленные и недорогие транзакции по всему миру без ожидания и международных сборов.",
  "custService": "Обслуживание клиентов",
  "helpLine": "Онлайн обслуживание клиентов",
  "contactUs": "Связаться с нами",
  "partner": "Кооперативные поставщики",
  "buyRules": "Правила покупателя",
  "客户端下载": "Загрузки клиента",
  "提现方式":"Способ вывода средств",
  "sellerRules": "Политика продавца",
  "returnsAndEx": "Возврат и обмен",
  "servicePolicy": "Политика обслуживания",
  "returnPolicy": "Политика возврата",
  "user_Center": "Пользовательский центр",
  "userReg": "Регистрация пользователя",
  "orderTrack": "Запрос заказа",
  "purchageHistory": "История покупки",
  "myPurse": "Мой бумажник",
  "aboutUs": "О нас",
  "Recruitment": "Ждите талантливых людей",
  "news": "Новостная информация",
  "stateMent": "Заявление о современном рабстве",
  "binance": "Бинанс",
  "huobi": "Хуоби",
  "okx": "хорошо",
  "metaMask": "Метамаск",
  "homeBannertips1": "Стать торговцем",
  "homeBannertips2": "Общая комиссия",
  "homeBannertips3": "Макс.",
  "homeBannerbtn": "Присоединяйся сейчас",
  "homeDownloadtips1": "Трансграничный оптовый торговый центр электронной коммерции",
  "homeDownloadtips2": "Специальное предложение бренда",
  "homeDownloadtips3": "Постоянная скидка",
  "homeDownloadtips4": "скачать андроид",
  "homeDownloadtips5": "Apple скачать",
  "homeDownloadtips6": "Отсканируйте QR-код, чтобы загрузить приложение",
  "homeIconTips1": "100% подлинный",
  "homeIconTips2": "возврат 7 дней",
  "homeIconTips3": "Скидка на фрахт",
  "homeIconTips4": "Безопасная оплата",
  "headerSearchTips": "Пожалуйста, введите ключевое слово для поиска",
  "collAccount": "Режим кредита",
  "mine": "Мой.",
  "creditText1": "Стартовые кредиты решают проблему заимствования денег",
  "creditText2": "Предоставление стартового кредита и услуг по обороту капитала",
  "creditWorry": "Кредит без забот",
  "creditQuota": "Гибкий лимит",
  "creditQuotaINFO": "От 100 000 до 30 000 000 с гибким лимитом и без ограничений, с максимальным сроком кредита один год.",
  "quickLoan": "Быстрый кредит",
  "creditReview": "Пройдите аудит не раньше, чем через час, если проверка будет пройдена, кредит будет выдан сразу.",
  "safe": "Безопасно и беззаботно",
  "safeInfo": "Ни ипотеки, ни залога, ни перезвона, ибо это на самом деле личное дело.",
  "about": "О нас",
  "aboutText1": "Мы привержены кредитным финансовым услугам, основанным на философии бизнеса «клиент прежде всего», придерживаемся миссии решения проблемы оборота капитала клиента. За время своего существования компания помогла многочисленным клиентам решить проблему оборота капитала.",
  "aboutText2": "Лимит: 100 000–30 000 000, гибкий метод погашения с низкой процентной ставкой, без первоначального взноса, онлайн-кредит, без телефонного звонка для подтверждения, конфиденциальная информация и кредитование в тот же день.",
  "contactUs1": "Если вы не хотите занимать деньги у своих товарищей по уровню, пожалуйста, свяжитесь с нами.",
  "committed": "Приверженность кредитным услугам для предпринимателей",
  "financial": "Решите свои финансовые проблемы",
  "partnersTit": "Партнер-Платформа онлайн-кредитования",
  "application": "Заявка на получение ссуды",
  "applicant": "Заявитель",
  "actualName": "Настоящее имя",
  "yourName": "Пожалуйста, введите имя",
  "term": "Срок кредита",
  "applicationAmount": "Запрашиваемая сумма",
  "rates": "Процентная ставка по кредиту",
  "loanMethod": "Режим кредита",
  "accountB": "Баланс",
  "countryOf": "Национальность",
  "myloan": "Мой кредит",
  "applyLoan": "Обращаться за ссудой",
  "loaned": "Ссуда",
  "interest": "Начисленные проценты",
  "esRepayment": "Расчетное погашение",
  "loanHistory": "Кредитная запись",
  "applicantDate": "Дата подачи документов",
  "repayment": "погашение",
  "cycle": "Цикл погашения",
  "fixedRate": "Фиксированная процентная ставка",
  "successLoan": "Кредит успешно",
  "Reapply": "Подать заявку повторно",
  "borrow": "Ссуда не удалась",
  "applicantIn": "Выполняется заявка",
  "repaid": "погашение",
  "overdue": "Просрочено",
  "estirepay": "Расчетное погашение",
  "loanDays": "Количество дней кредита",
  "reAmount": "Сумма погашения",
  "repay": "Режим погашения",
  "entRepay": "Подтвердить погашение",
  "foryourmoney": "Если вам не хватает средств, вам негде взять деньги в долг или вы стесняетесь брать деньги взаймы у своих друзей, вы можете связаться с нами. У нас есть весь процесс профессионального обслуживания, чтобы ответить на ваши сомнения в любое время. Наша цель — сделать каждый кредит прозрачным, чтобы клиенты могли его использовать быстро и уверенно.",
  "onlineApplin": "Подать заявку онлайн",
  "businessloan": "Заявка на стартовый кредит",
  "selectCountry": "Пожалуйста, выберите национальность",
  "selectPeriod": "Выберите период",
  "passPortImg": "№ удостоверения личности/номер паспорта",
  "uploadId": "Загрузка фото сертификата/паспорта",
  "readAndAgree": "Я прочитал и согласен",
  "loanAgree": "Договор о кредите",
  "submitApplica": "Подача заявки",
  "photoExample": "Пример съемки",
  "discounted": "Товары со скидкой",
  "days": "день",
  "privacyPolicy": "Политика конфиденциальности",
  "delivery": "Доставка и самовывоз",
  "checkAgreement": "Пожалуйста, отметьте соглашение!",
  "businessPhone": "Рабочий телефон",
  "businessEmail": "Корпоративная электронная почта",

  "提交失败": "Отправить не удалось",
  "充值金额不能小于1": "Сумма пополнения не может быть меньше 1 (включая два знака после запятой)",
  "请切换其他语言后查看": "Пожалуйста, переключитесь на другой язык для просмотра",
  "我的购物车": "Моя корзина",
  "推荐商品": "Рекомендуемые продукты",
  "猜你喜欢": "Думаю, вам это нравится.",
  "暂无店铺": "Магазин не найден",
  "添加失败": "Не удалось отправить. Пожалуйста, повторите попытку позже",
  "提交订单": "Подача заказа",
  recommendclass: "Рекомендуемые категории",
  "滑动验证": "Проверка на скользящую панель",
  "最多上传9张图片": "Максимум 9 изображений",
  "账号注销": "Отмена учетной записи",
  "确定注销": "Подтвердить отмену",
  "您的账号": "Ваша учетная запись",
  "为什么要离开": "Почему вы уходите?",
  "App下载(买家端)": "Загрузка приложения (покупатель)",
  "App下载(卖家端)": "Загрузка приложения (продавец)",
  "您还有余额,不能注销账号": "У вас есть остаток, вы не можете отменить учетную запись!",
  "请输入注销理由": "Пожалуйста, введите причину отмены",
  "您确认要注销吗?": "Вы уверены, что хотите отменить?",
  "我再考虑下": "Я еще подумаю",
  "同意注销": "Согласиться с отменой",
  "注销成功": "Отмена успешна",
  "最多包含10位小数": "Максимум 10 десятичных знаков",
  "企业电话": "Контактный телефон",
  "加密货币": "Криптовалюта",
  "职业机会": "Карьерная перспектива",
  "银行卡": "Банковская карта",
  "充值币种": "Валюта пополнения",
  "充值金额": "Сумма пополнения",
  '参数缺失': "Отсутствует параметр",
  '充值数量必填': "Количество пополнения обязательно",
  "充值金额不得小于": "Сумма пополнения не может быть меньше",
  "长时间未付款，系统自动取消订单": "Долгое время не оплачивается, система автоматически отменяет заказ",
  "充值金额不得大于": "Сумма пополнения не может быть больше",
  "请先选择币种": "Пожалуйста, выберите валюту",
  "开户行": "Банк",
  "请输入开户行名称": "Пожалуйста, введите название банка",
  "银行卡号": "Номер банковской карты",
  "点击去支付": "Нажмите, чтобы оплатить",
  "企业证明": "Корпоративное подтверждение",
  "请输入银行卡号": "Пожалуйста, введите номер банковской карты",
  footTipTikTok:'Торговый центр BizSpring ©️2024 Copyright',
  TikTokFoot:'BizSpring — это глобальная социальная платформа для коротких видеороликов BizSpring и крупнейшая в Азии оптовая торговая компания Alibaba, созданная в сотрудничестве. Это глобальная платформа электронной коммерции, которая имеет три самоуправляемых интеллектуальных склада в мире, расположенных в Торонто, Канада, Лос-Анджелесе и Тибе, Япония. В приложении продаются популярные товары из Японии, Южной Кореи, Китая и других азиатских стран. В настоящее время их общее число превысило 50 000 и продолжает быстро расти.',
  "cancelInfo":"предупреждать! Пожалуйста, будьте осторожны при удалении учетной записи. Если вы больше не используете учетную запись, вы можете нажать [Согласен на отмену]. Возможно, вы не сможете зарегистрироваться в течение нескольких дней после отмены."
,
  "getCouponSuccess": "Получено успешно",
  "liveRooms": "Прямые трансляции",
  "liveStreaming": "Прямой эфир",
  "notStarted": "Не начато",
  "finished": "Завершено",
  "myPoints": "Мои баллы",
  "searchGoods": "Поиск товаров",
  "points": "Баллы",
  "point": "Баллы",
  "stock": "В наличии",
  "spec": "Характеристика",
  "exchangeNow": "Обменять",
  "currentPoint": "Мои баллы",
  "pointNotEnough": "Недостаточно баллов"

,
    "contactInfo": "Contact Information",
    "consignee": "Full Name",
    "phone": "Phone",
    "enterName": "Enter full name",
    "enterPhone": "Enter phone number",
    "country": "Country",
    "province": "State/Province",
    "detailAddress": "Detail Address",
    "enterAddress": "Enter street address",
    "paymentInfo": "Payment Information",
    "cardNumber": "Card Number",
    "cardHolder": "Cardholder Name",
    "enterCardHolder": "Enter cardholder name",
    "expiryDate": "Expiry Date",
    "cardNumberRequired": "Card number is required",
    "cardHolderRequired": "Cardholder name is required",
    "expiryDateRequired": "Expiry date is required",
    "emailRegistered": "This email is already registered. You can login after checkout.",
    "nameRequired": "Name is required",
    "phoneRequired": "Phone is required",
    "countryRequired": "Country is required",
    "addressRequired": "Address is required",
    "cardExpired": "Card has expired",
    "registerFailed": "Registration failed",
    "accountExists": "Account already exists, please login to continue",
    "operationFailed": "Operation failed",
    "continueToCheckout": "Continue to Checkout",
    "emailRequired": "Email is required",
    "emailInvalid": "Invalid email format",
    "中文繁體": "繁體中文",
    "中文简体": "简体中文",
    "日本語": "日本語",
    "shoppingCart": "Shopping Cart",
    "selectAll": "Select All",
    "goodsName": "Product Name",
    "subtotal": "Subtotal",
    "action": "Action",
    "selected": "Selected",
    "total": "Total",
    "emptyCart": "Your shopping cart is empty",
    "allStores": "All Stores",
    "searchStore": "Search stores",
    "viewStore": "Visit Store",
    "streamEnded": "Stream Ended",
    "liveGoods": "Live Products",
    "announcements": "Announcements",
    "pointHistory": "Points History",
    "type": "Type",
    "remark": "Remark",
    "accountBind": "Account Binding",
    "mobileBind": "Mobile Binding",
    "notBound": "Not Bound",
    "change": "Change",
    "bind": "Bind",
    "emailBind": "Email Binding",
    "enterMobile": "Enter mobile number",
    "enterEmail": "Please enter email",
    "verifyCode": "Verification Code",
    "enterCode": "Enter verification code",
    "sendCode": "Send Code",
    "codeSent": "Code sent successfully",
    "bindSuccess": "Binding succeeded",
    "save": "Save",
    "saveSuccess": "Saved successfully",
    "balancePay": "Balance Pay",
    "wechatPay": "WeChat Pay",
    "alipay": "Alipay",
    "totalAmount": "Total Amount",
    "confirmPay": "Confirm Payment",
    "paySuccess": "Payment succeeded",
    "renew": "Renew",
    "vipPrivileges": "VIP Privileges",
    "growthValue": "Growth Value",
    "expiry": "Expiry",
    "pointLottery": "Points Lottery",
    "costPoints": "Cost Points",
    "startLottery": "Start Lottery",
    "congratulations": "Congratulations",
    "betterLuckNextTime": "Better luck next time",
    "noLottery": "No lottery available",
    "insufficientPoints": "Insufficient points",
    "pendingComment": "Pending Review",
    "commented": "Reviewed",
    "close": "Close",
    "loginFail": "Login failed",
    "paymentFailed": "Payment failed",
    "subscribe": "Subscribe",
    "confirmDelete": "Are you sure you want to delete?",
    "tips": "Tips",
    "deleteSuccess": "Deleted successfully",
    "KEY": "俄语(ru)",
    "addImageHint": "(Добавьте изображения)",
    "deleteNode": "Удалить",
    "topPos": "Верх {n}",
    "col": "Колонка {n}",
    "pos": "Позиция {n}",
    "decoType_container": "Контейнер",
    "decoType_title": "Текст заголовка",
    "decoType_richText": "Форматированный текст",
    "decoType_notice": "Объявление",
    "decoType_blank": "Отступ",
    "decoType_banner": "Карусель",
    "decoType_imageSingle": "Одно изображение",
    "decoType_imageMulti": "Несколько изображений",
    "decoType_video": "Видео",
    "decoType_goodsRecommend": "Рекомендации товаров",
    "decoType_goodsSelection": "Подборка товаров",
    "decoType_seckill": "Флеш-распродажа",
    "decoType_groupBuy": "Групповая покупка",
    "decoType_coupon": "Купон",
    "decoType_searchNav": "Навигация поиска",
    "decoType_search": "Поле поиска",
    "decoType_searchBox": "Поле поиска",
    "decoType_categoryNav": "Навигация по категориям",
    "decoType_goodsCategory": "Категория товаров",
    "decoType_navIconRow": "Значки навигации",
    "decoType_imageScroll": "Прокрутка изображений",
    "decoType_pageBanner": "Баннер страницы",
    "decoType_tabs": "Вкладки",
    "decoType_brand": "Бренд",
    "decoType_storeRecommend": "Рекомендуемые магазины",
    "decoType_hotSelection": "Популярный выбор",
    "decoType_footerLinkGroup": "Ссылки в подвале",
    "decoType_partnerLogoRow": "Партнёры",
    "decoType_icpInfo": "Инфо ICP",
    "decoType_topNavMenu": "Верхняя навигация",
    "decoType_logoBlock": "Логотип",
    "decoType_langSwitcher": "Язык",
    "decoType_currencySwitcher": "Валюта",
    "decoType_loginBlock": "Вход",
    "decoType_cartIcon": "Корзина",
    "decoType_messageIcon": "Сообщения",
    "seckillPrice": "Цена распродажи",
    "seckillTag": "Флеш-распродажа",
    "seckillCountdown": "До конца",
    "seckillNotStarted": "Скоро",
    "seckillRushing": "Идёт сейчас",
    "seckillWillStart": "Скоро",
    "seckillBuy": "Купить (распродажа)",
    "groupPrice": "Групповая цена",
    "groupRequiredNum": "чел. для группы",
    "noGroupBuy": "Купить одному",
    "groupRule1": "1. Выберите товар",
    "groupRule2": "2. Начните группу",
    "groupRule3": "3. Группа собрана → отправка",
    "marketingMoneyOff": "Скидка",
    "marketingFreeShipping": "Бесплатная доставка",
    "marketingGift": "Подарок",
    "marketingCoupon": "Купон",
    "marketingGroup": "Групповая покупка",
    "marketingSeckill": "Распродажа",
    "marketingExpired": "Акция завершена",
    "marketingNotActive": "Акция неактивна",
    "alreadyGotCoupon": "Получено",
    "couponReceived": "Получено",
    "hotSearch": "Популярный поиск:"
}